// extracted by mini-css-extract-plugin
module.exports = {"comment":"ProductCommentsFormatter_comment__24LHt","commentCount":"ProductCommentsFormatter_commentCount__1ijsr"};